import type { Mercury } from '@repo/types/Models';

/**
 * Sorts an array of SMS objects by their udhSeqNum in ascending order
 * @param smsArray Array of SMS objects to sort
 * @returns A new sorted array of SMS objects
 */
function sortSmsByUdhSeqNum(smsArray: Mercury.Models.SMS[]): Mercury.Models.SMS[] {
  return [...smsArray].sort((a, b) => {
    // Handle undefined values by treating them as 0 or placing them at the beginning
    const seqNumA = a.udhSeqNum ?? 0;
    const seqNumB = b.udhSeqNum ?? 0;

    return seqNumA - seqNumB;
  });
}

export default function orderMessageSegments(segments: Mercury.Models.SMS[]): Mercury.Models.SMS[] {
  return sortSmsByUdhSeqNum(segments);
}
